/* @flow */
import AdminBillingContactForm from './AdminBillingContactForm';

export default AdminBillingContactForm;
